import { useIsQuoted } from 'components/common-form/hooks/useIsQuoted';
import type { HighlightColor } from 'components/shared/NumberFormatter/NumberFormatter.model';

// Highlight color for solvable (auto-solve) fields: green when quoted, otherwise the side-panel pricing turquoise.
export function useHighlightColor(): HighlightColor {
  const isQuoted = useIsQuoted();

  return isQuoted ? 'success' : 'turquoise';
}
